
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageBeforeIn: function () {
      this.$app.statusbar.setBackgroundColor('#ffffff');
      this.$app.statusbar.setTextColor('black');
    },
    pageInit: function (e, page) {
      var app = this.$app;
      var $$ = this.$;
      var ctx = page.route.context || {};
      var listEndpoint = ctx.listEndpoint || '';
      var perPage = ctx.perPage || 10;
      var currentPage = ctx.currentPage || 1;
      var hasMore = !!ctx.hasMore;
      var loadingMore = false;
      if (!listEndpoint || !hasMore)
        return;
      function esc(s) {
        if (s === null || s === undefined)
          return '';
        return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
      }
      function renderHospitalCard(h) {
        var img = h.image_url ? h.image_url : 'static/img/default_hospital.svg';
        return '<a href="/hospital/' + esc(h.id) + '/' + esc(h.name) + '/" class="hospital-card-v2" aria-label="' + esc(h.name) + '">' + '<div class="hospital-card-v2-image"><img src="' + esc(img) + '" alt="" onerror="this.src=\'static/img/default_hospital.svg\'"></div>' + '<div class="hospital-card-v2-name">' + esc(h.name) + '</div>' + '</a>';
      }
      function loadNextPage() {
        if (loadingMore || !hasMore)
          return;
        loadingMore = true;
        $$('#allHospitalsPreloader').show();
        var nextPage = currentPage + 1;
        var url = app.data.remoteUrl + listEndpoint + '&page=' + nextPage + '&per_page=' + perPage;
        app.request({
          url: url,
          method: 'GET',
          dataType: 'json',
          success: function (response) {
            $$('#allHospitalsPreloader').hide();
            loadingMore = false;
            var payload = response && response.data ? response.data : {};
            var list = payload && payload.data ? payload.data : [];
            var meta = payload && payload.meta ? payload.meta : {};
            if (list.length) {
              var html = '';
              list.forEach(function (h) {
                html += renderHospitalCard(h);
              });
              $$('#hospitalsGrid').append(html);
              currentPage = nextPage;
              hasMore = !!meta.has_more;
              if (!hasMore)
                app.infiniteScroll.destroy('#allHospitalsPage');
            } else {
              hasMore = false;
              app.infiniteScroll.destroy('#allHospitalsPage');
            }
          },
          error: function () {
            $$('#allHospitalsPreloader').hide();
            loadingMore = false;
          }
        });
      }
      $$('#allHospitalsPage').on('infinite', loadNextPage);
    }
  },
  id: 'b1edb50612',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page listing-page" data-name="all-hospitals">\n        <div class="navbar">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">All Hospitals</div>\n            </div>\n        </div>\n        <div class="page-content infinite-scroll-content" id="allHospitalsPage" data-infinite-distance="80">\n            ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.data && this.data.length', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="listing-intro">\n                <div class="listing-intro-title">Top hospitals near you</div>\n                <div class="listing-intro-sub">Pick a hospital to view its doctors.</div>\n            </div>\n            <div class="hospital-grid" id="hospitalsGrid">\n                ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.data, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n                <a href="/hospital/';
              r += c(ctx_3.id, ctx_3);
              r += '/';
              r += c(ctx_3.name, ctx_3);
              r += '/" class="hospital-card-v2" aria-label="';
              r += c(ctx_3.name, ctx_3);
              r += '">\n                    <div class="hospital-card-v2-image">\n                        <img src="';
              r += c(ctx_3.image_url, ctx_3);
              r += '" alt="" onerror="this.src=\'static/img/default_hospital.svg\'">\n                    </div>\n                    <div class="hospital-card-v2-name">';
              r += c(ctx_3.name, ctx_3);
              r += '</div>\n                </a>\n                ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n            </div>\n\n            <!-- Infinite scroll preloader -->\n            <div class="preloader infinite-scroll-preloader" id="allHospitalsPreloader" style="display: none;">\n                <span class="preloader-inner">\n                    <span class="preloader-inner-gap"></span>\n                    <span class="preloader-inner-left"><span class="preloader-inner-half-circle"></span></span>\n                    <span class="preloader-inner-right"><span class="preloader-inner-half-circle"></span></span>\n                </span>\n            </div>\n            ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="empty-state">\n                <img src="static/img/default_hospital.svg" alt="">\n                <div class="empty-state-title">No hospitals available</div>\n                <div class="empty-state-sub">Please check back in a little while.</div>\n            </div>\n            ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    